module.exports = __webpack_public_path__ + "static/media/placeholder.f709e741.svg";